import {useMutation} from 'react-query';

import {deleteMessage} from '../../../services/message';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const useRemoveMessage = (refetch: () => void) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IRemoveMessagePayload) => {
      return deleteMessage(payload);
    },
    onSuccess: () => {
      refetch();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });
  return {isLoading, mutate, isSuccess};
};

export default useRemoveMessage;
